// custom-button.js
import React from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  containedButton: {
    backgroundColor: "#2D303A", // Dark charcoal color from screenshot
    color: "#fff",
    borderRadius: 4, // Less rounded corners to match screenshot
    padding: theme.spacing(1, 2), // Reduced padding
    textTransform: "none", // No uppercase text
    fontWeight: 500,
    height: 42, // Reduced height from 56px
    minWidth: 120, // Reduced width from 200px
    '&:hover': {
      backgroundColor: "#1D1F27", // Slightly darker on hover
    },
    '&:disabled': {
      backgroundColor: "#6c6f7e",
      color: "rgba(255, 255, 255, 0.7)",
    },
  },
  linkButton: {
    backgroundColor: "transparent",
    color: "#2D303A",
    padding: theme.spacing(1, 3),
    textTransform: "none", // No uppercase text
    '&:hover': {
      backgroundColor: "transparent",
      textDecoration: "none",
    },
  },
  loader: {
    marginLeft: theme.spacing(1),
    color: "#FFFFFF",
  },
  loaderLink: {
    marginLeft: theme.spacing(1),
    color: "#2D303A",
  },
  // New styles for newsletter button
  newsletterButton: {
    backgroundColor: "#2D303A", // Dark charcoal color from screenshot
    color: "#fff",
    borderRadius: 4, // Less rounded corners to match screenshot
    padding: theme.spacing(1, 2), // Reduced padding
    textTransform: "none", // No uppercase text
    height: 42, // Reduced height
    minWidth: 120, // Add minimum width
    fontWeight: 500,
    '&:hover': {
      backgroundColor: "#1D1F27", // Slightly darker on hover
    },
  },
  // Button with end icon
  endIcon: {
    marginLeft: theme.spacing(1),
  }
}));

const CustomButton = ({
  children = undefined,
  onClick,
  style = {},
  variant = "contained",
  loading = false,
  color = "default",
  endIcon = undefined,
  ...props
}) => {
  const classes = useStyles();

  let buttonClass;
  if (variant === "link") {
    buttonClass = classes.linkButton;
  } else if (color === "newsletter") {
    buttonClass = classes.newsletterButton;
  } else {
    buttonClass = classes.containedButton;
  }

  return (
    <
// @ts-ignore
    Button
      className={buttonClass}
      onClick={loading ? undefined : onClick}
      style={style}
      disabled={loading || props.disabled}
      variant={variant === "link" ? "text" : variant}
      color={color !== "newsletter" ? color : undefined}
      {...props}
    >
      {children}
      {endIcon && <span className={classes.endIcon}>{endIcon}</span>}
      {loading && (
        <CircularProgress
          size={20}
          className={variant === "contained" ? classes.loader : classes.loaderLink}
        />
      )}
    </Button>
  );
};

CustomButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
  variant: PropTypes.oneOf(["contained", "link", "outlined", "text"]),
  color: PropTypes.oneOf(["default", "primary", "secondary", "newsletter"]),
  loading: PropTypes.bool,
  endIcon: PropTypes.node,
};

CustomButton.defaultProps = {
  onClick: () => {},
  style: {},
  variant: "contained",
  loading: false,
  color: "default",
};

export default CustomButton;
